import { profilesApi } from "@/api"

export const requestOTPForProfile = (email: string) =>
        profilesApi.requestOTPForProfile({
            profile: { unconfirmed_email: email }
        })

export const verifyOTPForProfile = (_: string, code: string) =>
    profilesApi.verifyOTPForProfile(code)
